import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {};

const enhance = compose();

const MenuTableHead = enhance(() => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell>Menu ID</TableCell>
        <TableCell>Shop ID</TableCell>
        <TableCell>Group ID</TableCell>
        <TableCell>Menu name</TableCell>
        <TableCell>Description</TableCell>
        <TableCell>Price</TableCell>
        <TableCell>Tax amount</TableCell>
        <TableCell>Included tax price</TableCell>
        <TableCell>Excluded tax price</TableCell>
        <TableCell>Tax type</TableCell>
        <TableCell>Reduced tax type</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(MenuTableHead);
